<div class="signature-column ">
    <div class="rounded-box" [ngClass]="{ 'bg-transparent': isPrintMode }">
        <canvas #signatureCanvas></canvas>
    </div>
    <div class="d-flex rleft">
        <div class="m-2">
            <button *ngIf="!hideActionsWhenDisabled || !disabled" type="button" (click)="signForm()" [disabled]="disabled" class="btn btn-secondary btn-xsm m-1">
                <i class="fas fa-signature"></i>
            </button>
            <button *ngIf="!hideActionsWhenDisabled || !disabled" type="button" (click)="removeSignature()" [disabled]="disabled" class="btn btn-warning btn-xsm m-1">
                <i class="fas fa-trash-alt"></i>
            </button>
        </div>
        <div>
            <ng-content></ng-content>
        </div>
    </div>
</div>
